export const DropboxPluginId = '55a5d915446f517774210002';
